require('./brokerWarrantsBuySuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @helpers
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
    TYPE_WARRANTS
} = require('constants/index');
const { analyticsId, catalogue } = require('../analytics/brokerWarrantsBuy.tracking');

// @utils
const { recordLinkV2 } = require('utilities/tagging');

const BrokerWarrantsBuySuccess = props => {
    const { productFile, immBrokerWarrantsBuy, immStocksContracts } = props;
    const mockedOrderNumber = immBrokerWarrantsBuy.getIn(['orderConfirmation', 'orderNumber']);
    const successMessage = formatText('broker-warrantsBuySuccessStepMessage');
    const successSubMessage = formatText('broker-warrantsBuySuccessStepSubMessage', [mockedOrderNumber]);
    const mainButtonLabel = formatText('broker-stocksSellSuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('broker-warrantsBuySuccessStepReviewOrdersButtonLabel');
    const step1 = immBrokerWarrantsBuy.get('steps').get(FIRST_STEP);
    const step2 = immBrokerWarrantsBuy.get('steps').get(SECOND_STEP);
    const stocksContractSelectedValue = immBrokerWarrantsBuy.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const stockContract = immStocksContracts.get(stocksContractSelectedValue);
    const confirmationMessage = formatText('broker-warrantsBuyLegalTextMessage');
    const productCurrency = productFile.get('currencyCode');

    React.useEffect(() => {
        recordLinkV2(catalogue[analyticsId.BROKER_WARRANTS_BUY_STEP_2_SUCCESS]())
    }, []);

    return (

        <WizardSuccess
            successMessage={successMessage}
            successSubMessage={successSubMessage}
            customClassName="warrants-buy-success"
            mainButton={{label: mainButtonLabel, url: MYPROFILE_BROKER_URL, modifier: 'secondary'}}
            secondaryButton={{label: secondaryButtonLabel, url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL}}
            tealium={catalogue[analyticsId.BROKER_WARRANTS_BUY_SUCCESS]({ productName: props.isin })}
            isSecondVersion
        >
            <StocksBuySellSummary
                productName={formatText('broker-warrantProductName')}
                productCurrency={productCurrency}
                stockContract={stockContract}
                stockDescription={productFile.get('companyName')}
                step1={step1}
                step2={step2}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                maskLimitOrderType={true}
                productType={TYPE_WARRANTS}
            />
            <ContactCenterRender>
                <OKMessage type="informative">
                    {confirmationMessage}
                </OKMessage>
            </ContactCenterRender>
        </WizardSuccess>
    );
};

BrokerWarrantsBuySuccess.propTypes = {
    productFile: PropTypes.object.isRequired,
    immBrokerWarrantsBuy: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = BrokerWarrantsBuySuccess;
